import { render } from "./ProviderNote.vue?vue&type=template&id=0a80c644"
import script from "./ProviderNote.vue?vue&type=script&lang=js"
export * from "./ProviderNote.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__